import styled from 'styled-components'

export const StyledLkMenu = styled.aside`
  border-right: 1px solid ${(props) => props.theme.colors.custom.primary[4]};
  grid-area: profile-menu;
  height: 100%;
  padding: 8px 0;
  width: 100%;
`
